import InlineComponent from './inlineComponent.jsx';
import HashForm from '../../../components/hash/HashForm.jsx';

module.exports = class OutputRenderer extends InlineComponent {
  define() {
    this.component = HashForm;
    this.defaults = {
      location: window.location,
    };
  }
};
